module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage2_m.b878b8c2b035bf0923ff86934a6b18f4.jpg";